package at.theatervogelweide.admin.contract.acts

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/**
 * Stücke & Termine (#22). The list is sorted by year, newest first, like the public archive.
 *
 * Images are uploaded over plain HTTP to `POST /api/images/acts` first; the [ActDraft] then names them by their ids,
 * and saving it attaches new images and removes the ones it no longer names, files included.
 */
@Rpc
interface ActService {
    suspend fun list(): AdminResult<List<ActListEntry>>

    suspend fun load(id: Long): AdminResult<ActEditor>

    /** Everyone who can be cast, sorted by name. */
    suspend fun people(): AdminResult<List<CastPerson>>

    /** What a new act starts with: the venue and admission of the newest act (#103), the rest empty. */
    suspend fun newDraft(): AdminResult<ActDraft>

    suspend fun create(draft: ActDraft): AdminResult<ActEditor>

    /** Replaces the performances and the cast with the draft's, in its order, like the public server's editor did. */
    suspend fun save(act: VersionedId, draft: ActDraft): AdminResult<ActEditor>

    /** Deletes the act with its performances, cast and images, files included. */
    suspend fun delete(act: VersionedId): AdminResult<Unit>
}
